import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
  CurrentAppViewOptions,
  CurrentAppViewState,
} from 'src/interfaces/store.types';
import type { RootState } from 'src/store';
import { useAppSelector } from 'src/store/redux';

const initialState: CurrentAppViewState = {
  currentAppView: null,
  isViewDefined: false,
  hasViewUpdated: false,
};

export const currentAppViewSlice = createSlice({
  name: 'currentAppView',
  initialState,
  reducers: {
    setCurrentAppView: (
      state,
      action: PayloadAction<CurrentAppViewOptions | null>,
    ) => {
      state.currentAppView = action.payload;
      state.hasViewUpdated = true;
    },
    setIsViewDefined: (state, action: PayloadAction<boolean>) => {
      state.isViewDefined = action.payload;
    },
    setHasViewUpdated: (state, action: PayloadAction<boolean>) => {
      state.hasViewUpdated = action.payload;
    },
  },
});

export const { setCurrentAppView, setIsViewDefined, setHasViewUpdated } =
  currentAppViewSlice.actions;

export const useCurrentAppViewSelector = () =>
  useAppSelector((state: RootState) => state.currentAppView.currentAppView);

export const useIsViewDefinedSelector = () =>
  useAppSelector((state: RootState) => state.currentAppView.isViewDefined);

export const useHasViewUpdatedSelector = () =>
  useAppSelector((state: RootState) => state.currentAppView.hasViewUpdated);

export default currentAppViewSlice.reducer;
